if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();

      const overlayPrev = this.querySelector('.gallery-nav-overlay__btn--prev');
      const overlayNext = this.querySelector('.gallery-nav-overlay__btn--next');
      if (overlayPrev) overlayPrev.addEventListener('click', () => this.navigateOverlay('prev'));
      if (overlayNext) overlayNext.addEventListener('click', () => this.navigateOverlay('next'));

    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      const previousActive = this.elements.viewer.querySelector('.is-active');
      const shouldAnimate = !prepend && previousActive && previousActive !== activeMedia
        && this.dataset.desktopLayout.includes('thumbnail');

      if (shouldAnimate) {
        const allSlides = Array.from(this.elements.viewer.querySelectorAll('[data-media-id]'));
        const direction = this.slideDirection
          || (allSlides.indexOf(activeMedia) > allSlides.indexOf(previousActive) ? 'next' : 'prev');
        delete this.slideDirection;

        previousActive.classList.remove('is-active');
        previousActive.classList.add('is-leaving');
        previousActive.style.animation = direction === 'next'
          ? 'galleryPushOutLeft 0.35s ease-in-out forwards'
          : 'galleryPushOutRight 0.35s ease-in-out forwards';
        previousActive.addEventListener('animationend', () => {
          previousActive.classList.remove('is-leaving');
          previousActive.style.animation = '';
        }, { once: true });

        activeMedia.classList.add('is-active');
        activeMedia.style.animation = direction === 'next'
          ? 'galleryPushInRight 0.35s ease-in-out forwards'
          : 'galleryPushInLeft 0.35s ease-in-out forwards';
        activeMedia.addEventListener('animationend', () => {
          activeMedia.style.animation = '';
        }, { once: true });
      } else {
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');
      }

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    navigateOverlay(direction) {
      if (!this.elements.thumbnails) return;
      const thumbnails = Array.from(this.elements.thumbnails.querySelectorAll('[data-target]'));
      const visibleThumbnails = thumbnails.filter(t => t.offsetParent !== null);
      if (visibleThumbnails.length === 0) return;

      const activeBtnEl = this.elements.thumbnails.querySelector('button[aria-current]');
      if (!activeBtnEl) return;

      const currentItem = activeBtnEl.closest('[data-target]');
      const currentIndex = visibleThumbnails.indexOf(currentItem);
      if (currentIndex === -1) return;

      const nextIndex = direction === 'next'
        ? (currentIndex + 1) % visibleThumbnails.length
        : (currentIndex - 1 + visibleThumbnails.length) % visibleThumbnails.length;

      this.slideDirection = direction === 'next' ? 'next' : 'prev';
      this.setActiveMedia(visibleThumbnails[nextIndex].dataset.target, false);
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
